import { Alert, Link } from "@mui/material";
import { useDocumentData } from "react-firebase-hooks/firestore";

export const OpenBankingConnectionStatus = ({ loading, openBanking }) => {
  // const [data] = useDocumentData(
  //   openBanking?.status === "invite-ready"
  //     ? openBanking.activeInvite
  //     : undefined
  // );

  if (loading) {
    return null;
  }

  if (!openBanking?.openBankingStatus) {
    return (
      <Alert sx={{ my: 2 }} severity="info">
        Open Banking connection not initiated
      </Alert>
    );
  }

  if (openBanking?.status === "invite-ready") {
    return (
      <Alert sx={{ my: 2 }} severity="info">
        Open Banking Connection initated, invite ready
        <br />
        <Link href={openBanking?.applicationUrl} target="_blank">
          {openBanking?.applicationUrl}
        </Link>
      </Alert>
    );
  }

  if (openBanking?.openBankingStatus === "Success" && !openBanking?.data?.raw) {
    return (
      <Alert sx={{ my: 2 }} severity="info">
        Calculations not fetched
      </Alert>
    );
  }

  if (openBanking.openBankingStatus === "Reject") {
    return (
      <Alert sx={{ my: 2 }} severity="warning">
        Open Banking connection was rejected
      </Alert>
    );
  }

  if (openBanking.openBankingStatus === "Cancelled") {
    return (
      <Alert sx={{ my: 2 }} severity="warning">
        Open Banking connection was cancelled
      </Alert>
    );
  }

  if (openBanking.openBankingStatus === "error") {
    return (
      <Alert sx={{ my: 2 }} severity="error">
        Open Banking connection error: {openBanking.status}
      </Alert>
    );
  }

  return null;
};
